var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContatoBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C9.55655 12 10.033 11.8042 10.4293 11.4125C10.8256 11.0208 11.0238 10.55 11.0238 10C11.0238 9.45 10.8256 8.97917 10.4293 8.5875C10.033 8.19583 9.55655 8 9 8C8.44345 8 7.96701 8.19583 7.57068 8.5875C7.17436 8.97917 6.97619 9.45 6.97619 10C6.97619 10.55 7.17436 11.0208 7.57068 11.4125C7.96701 11.8042 8.44345 12 9 12ZM4.95238 16H13.0476V15.425C13.0476 15.025 12.938 14.6583 12.7188 14.325C12.4995 13.9917 12.1959 13.7417 11.808 13.575C11.3695 13.3917 10.9184 13.25 10.4546 13.15C9.99082 13.05 9.50595 13 9 13C8.49405 13 8.00918 13.05 7.54539 13.15C7.0816 13.25 6.63046 13.3917 6.19196 13.575C5.80407 13.7417 5.5005 13.9917 5.28125 14.325C5.062 14.6583 4.95238 15.025 4.95238 15.425V16ZM15.5774 20H2.42262C2.01786 20 1.66369 19.85 1.36012 19.55C1.05655 19.25 0.904762 18.9 0.904762 18.5V1.5C0.904762 1.1 1.05655 0.75 1.36012 0.45C1.66369 0.15 2.01786 0 2.42262 0H11.0491L17.0952 5.975V18.5C17.0952 18.9 16.9435 19.25 16.6399 19.55C16.3363 19.85 15.9821 20 15.5774 20ZM15.5774 18.5V6.65L10.3661 1.5H2.42262V18.5H15.5774Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContatoBranco);
export default __webpack_public_path__ + "static/media/contatoBranco.925a78e99cdbc9c1cb566a15a591ea80.svg";
export { ForwardRef as ReactComponent };